import { Tooltip } from '@mantine/core';
import React, { PropsWithChildren, useState } from 'react';

interface Props {
	label: React.ReactNode;
	shouldShowTooltip: boolean;
	style?: React.CSSProperties;
	width?: number;
	multiLine?: boolean;
}
export const ConditionalTooltip = (props: PropsWithChildren<Props>) => {
	const { shouldShowTooltip, label, children, width = 240, multiLine = true, style } = props;

	const [showTooltip, setShowTooltip] = useState(false);

	const handlePointerEnter = () => {
		if (shouldShowTooltip) {
			setShowTooltip(true);
		}
	};

	const handleMouseLeave = () => {
		setShowTooltip(false);
	};

	return (
		<Tooltip
			label={label}
			multiline={multiLine}
			opened={showTooltip}
			w={width}
			withinPortal={true}
			style={style}
			styles={{
				tooltip: {
					overflowWrap: 'break-word',
					maxWidth: 'inherit',
					whiteSpace: 'break-spaces',
				},
			}}
		>
			<div
				onPointerEnter={handlePointerEnter}
				onPointerLeave={handleMouseLeave}
				style={{
					overflowWrap: 'break-word',
					maxWidth: 'inherit',
					whiteSpace: 'break-spaces',
				}}
			>
				{children}
			</div>
		</Tooltip>
	);
};
